import React, { useState, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { Grid, IconButton, Paper } from '@mui/material';
import Search from '../../../../../../assets/svg/search.svg';
import { FeedbackAlert, Image } from '../../../../../../components';
import FeatureSearchInput from './FeatureSearchInput';
import { resetFilteredEvents } from '../../../../../../core/events/action';
import { formatDate } from '../../../../../../utils';
import { getRegisteredVenueOwners } from '../../../../../../core/users/action';

function VenueSearchBar() {
  const dispatch = useDispatch();
  const [isFeedbackVisible, setIsFeedbackVisible] = useState(false);
  const [venueFilter, setVenueFilter] = useState({
    name: '',
    date: '',
    location: '',
  });

  const areFiltersEmpty = useMemo(
    () => Object.keys(venueFilter).every((key) => venueFilter[key] === ''),
    [venueFilter],
  );

  useEffect(() => {
    if (!areFiltersEmpty) return;
    dispatch(getRegisteredVenueOwners());
  }, [areFiltersEmpty, dispatch]);

  const handleSearch = () => {
    if (areFiltersEmpty) return;
    dispatch(getRegisteredVenueOwners(venueFilter));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setVenueFilter((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <>
      <Paper elevation={3} sx={{ borderRadius: 10, width: '80vw' }}>
        <Grid container>
          <Grid item xs={4}>
            <FeatureSearchInput
              label="Name"
              name="name"
              fieldValue={venueFilter?.name}
              onChange={handleChange}
              placeholder="What?"
            />
          </Grid>
          <Grid item xs={3}>
            <FeatureSearchInput
              label="Date"
              name="date"
              fieldValue={venueFilter?.date}
              onChange={handleChange}
              inputType="date"
              placeholder="When?"
            />
          </Grid>
          <Grid item xs={3}>
            <FeatureSearchInput
              label="Location"
              name="location"
              fieldValue={venueFilter?.location}
              onChange={handleChange}
              placeholder="Where?"
            />
          </Grid>
          <Grid item xs={2} display="flex" alignItems="center" justifyContent="center">
            <IconButton
              sx={{ width: '100%', height: '100%', borderRadius: 0 }}
              onClick={handleSearch}>
              <Image src={Search} alt="search icon" />
            </IconButton>
          </Grid>
        </Grid>
      </Paper>
      <FeedbackAlert
        message="No owners were found!"
        severity="warning"
        open={isFeedbackVisible}
        handleClose={() => setIsFeedbackVisible(false)}
      />
    </>
  );
}

export default VenueSearchBar;
